import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Trans } from "react-i18next";
import ActionButton from "../ActionButton";
const styles = (theme) => ({
  page: {
    padding: 20,
    maxHeight: "84%",
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  error: {
    color: theme.palette.error.light,
  },
});

export default function(WrappedComponent) {
  return withStyles(styles)(
    class extends Component {
      state = {
        nextDisabled: false,
        disabledHelperText: "",
        incomplete: [],
        unsaved: [],
        openAddReusableSection: false,
      };

      childNext = () => {
        this.props.next();
      };

      getButtonContainerStyle = () => {
        if (this.props.edit && this.props.noBackground) {
          return {
            display: "flex",
            right: 0,
            bottom: 0,
            left: 0,
            width: "100%",
            backgroundColor: "#fff",
            padding: 10,
          };
        } else if (this.props.edit) {
          return {
            display: "flex",
            position: "fixed",
            right: 0,
            bottom: 0,
            left: 0,
            width: "100%",
            backgroundColor: "#fff",
            boxShadow: "0px -3px 5px 0px rgba(0,0,0,0.15)",
            padding: 10,
          };
        } else {
          return {
            display: "flex",
            marginTop:
              this.state.disabledHelperText && this.state.nextDisabled ? 0 : 24,
          };
        }
      };

      render() {
        const { classes } = this.props;
        return (
          <Paper
            className={classes.page}
            style={{
              display: this.props.show ? null : "none",
              maxHeight: this.props.fullHeight ? "calc(100% - 40px)" : "76%",
            }}
            elevation={this.props.noElevation && 0}
          >
            <div style={{ flex: 1, minHeight: 0, display: "flex" }}>
              <WrappedComponent
                {...this.props}
                ref={this.childRef}
                next={this.childNext}
                setNextDisabled={(nextDisabled) =>
                  this.setState({ nextDisabled })
                }
                openAddReusableSection={this.state.openAddReusableSection}
                onCloseAddReusableSection={() =>
                  this.setState({ openAddReusableSection: false })
                }
                setIncomplete={(incomplete) => this.setState({ incomplete })}
                setUnsaved = {(unsaved) => this.setState({unsaved})}
                setDisabledHelperText={(disabledHelperText) =>
                  this.setState({ disabledHelperText })
                }
              />
            </div>
            <div style={this.getButtonContainerStyle()}>
              {this.props.isEnd ? (
                <div style={{ flex: 1, justifyContent: "flex-end" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.props.restart}
                    style={{ float: "right" }}
                  >
                    <Trans i18nKey="create_content_create_another">
                      create_content_create_another
                    </Trans>
                  </Button>
                </div>
              ) : (
                <>
                  {!this.props.isStart && (
                    <div
                      style={{
                        flex: 1,
                        justifyContent: "flex-start",
                        marginTop:
                          this.state.disabledHelperText &&
                          this.state.nextDisabled
                            ? 24
                            : 0,
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.props.back}
                        style={{ marginRight: this.props.edit ? 25 : 0 }}
                      >
                        {this.props.backText ? (
                          this.props.backText
                        ) : (
                          <Trans i18nKey="global_back" />
                        )}
                      </Button>
                    </div>
                  )}
                  <div style={{ flex: 1, justifyContent: "flex-end" }}>
                    <div style={{ float: "right", height: "100%" }}>
                      {this.state.nextDisabled &&
                        this.state.disabledHelperText && (
                          <Typography
                            variant="body2"
                            style={{ fontSize: "0.825rem" }}
                          >
                            {this.state.disabledHelperText}
                          </Typography>
                        )}
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        {this.props.activeStep === 1 && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() =>
                              this.setState({ openAddReusableSection: true })
                            }
                            style={{ marginRight: 6 }}
                          >
                            Add reusable section
                          </Button>
                        )}
                        {!this.props.noNext && (
                          <ActionButton
                            variant="contained"
                            color="primary"
                            onClick={() => this.props.next()}
                            disabled={
                              this.state.nextDisabled ||
                              this.state.incomplete.length > 0 ||
                              this.state.unsaved.length > 0
                            }
                            loading={this.props.loading}
                            style={{
                              float: "right",
                              marginRight: this.props.edit ? 25 : 0,
                            }}
                          >
                            {this.props.nextText ? (
                              this.props.nextText
                            ) : (
                              <Trans i18nKey="global_next" />
                            )}
                          </ActionButton>
                        )}
                      </div>
                    </div>
                    {this.props.showSkipButton && (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => this.props.next()}
                          style={{ float: "right", marginRight: 5 }}
                        >
                          <Trans i18nKey="global_skip" />
                        </Button>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          </Paper>
        );
      }
    }
  );
}
